import React, { useEffect, useState } from "react";
import { fetchFeedDataForFriends } from "../Utils/UFFetchFeeddata";
import { fetchSuggestedUsers } from "../Utils/fetchSuggestedUsers";
import "../Styles/UFGridCentreLowerLayout.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PageProfileModal from "../../../../../common/PopupPages/PageProfile";
import {
  faVideoCamera,
  faMobile,
  faMessage,
  faCheck,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import "../../../Styles/ua-common-styles.css";
import "../../../../Styles/common-styles.css";

const UFGridLowerLayout = ({ 
  selectedProfileId, 
  renderOperation, 
  setRenderOperation,
  selectedFriends = [],
  onFriendSelect,
  friendsTab = "current"
}) => {
  const [Friends, setFriends] = useState([]);
  const [suggestedUsers, setSuggestedUsers] = useState([]);
  const [suggestedConnections, setSuggestedConnections] = useState({});
  const [isLoadingSuggested, setIsLoadingSuggested] = useState(false);

  const handleCloseModal = () => {
    setRenderOperation(null);
  };

  // Load current friends
  useEffect(() => {
    async function loadFriends() {
      try {
        const data = await fetchFeedDataForFriends();
        if (data && Array.isArray(data.friendList)) {
          setFriends(data.friendList);
        } else {
          setFriends([]);
        }
      } catch (error) {
        console.error("Error fetching friends data:", error);
        setFriends([]);
      }
    }
    loadFriends();
  }, []);

  // Load suggested users
  useEffect(() => {
    async function loadSuggestedUsers() {
      setIsLoadingSuggested(true);
      try {
        const data = await fetchSuggestedUsers();
        if (data && Array.isArray(data.users)) {
          setSuggestedUsers(data.users);
        } else {
          setSuggestedUsers([]);
        }
      } catch (error) {
        console.error("Error fetching suggested users:", error);
        setSuggestedUsers([]);
      } finally {
        setIsLoadingSuggested(false);
      }
    }
    loadSuggestedUsers();
  }, []);

  const handleClick = (operationType, userId, mode) => {
    setRenderOperation({
      operationType,
      data: { userId },
      mode,
    });
  };

  const handleCheckboxChange = (friendId) => {
    const isSelected = selectedFriends.includes(friendId);
    if (isSelected) {
      onFriendSelect(selectedFriends.filter(id => id !== friendId));
    } else {
      onFriendSelect([...selectedFriends, friendId]);
    }
  };

  const isFriendSelected = (friendId) => {
    return selectedFriends.includes(friendId);
  };

  const handleConnectionToggle = (userId, userName) => {
    setSuggestedConnections((prev) => {
      const isConnected = prev[userId];
      if (isConnected) {
        console.log(`Connection request dropped for ${userName}`);
        return { ...prev, [userId]: false };
      } else {
        console.log(`Connection request sent to ${userName}`);
        return { ...prev, [userId]: true };
      }
    });
  };

  const hasConnectionRequest = (userId) => {
    return suggestedConnections[userId] || false;
  };

  return (
    <div style={{ 
      padding: "20px", 
      backgroundColor: "var(--card-bg, rgb(4, 4, 4))",
      minHeight: "100vh",
      overflow: "auto", 
      alignItems: "center", 
      justifyContent: "center",
      width: "100%",
    }}>
      
      {friendsTab === "current" ? (
        
        // ✅ CURRENT FRIENDS SECTION
        <div style={{ width: "90%" }}>
          <h3 style={{ 
            color: "white", 
            marginBottom: "20px", 
            fontSize: "18px", 
            fontWeight: "600",
          }}>
            Current Friends ({Friends.length})
          </h3>
          
          {Friends.length === 0 ? (
            <p style={{ textAlign: "center", color: "rgba(255,255,255,0.6)", padding: "40px 0" }}>
              No friends found
            </p>
          ) : (
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(5, 1fr)",
              gap: "16px",
              width: "100%",
            }}>
              {Friends.map((friend) => {
                return (
                  <div 
                    key={friend.friendid}
                    className="uf-profile-card-updated" 
                    style={{ 
                      display: "flex", 
                      flexDirection: "column", 
                      padding: "16px",
                      position: "relative",
                      border: "1px solid rgba(255,255,255,0.2)",
                      transition: "all 0.3s ease",
                      borderRadius: "12px",
                      backgroundColor: "rgba(255,255,255,0.05)",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.08)";
                      e.currentTarget.style.transform = "translateY(-2px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.05)";
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    {/* Checkbox in top right corner */}
                    <div 
                      style={{
                        position: "absolute",
                        top: 10,
                        right: 10,
                        zIndex: 10,
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <input
                        type="checkbox"
                        checked={isFriendSelected(friend.friendid)}
                        onChange={() => handleCheckboxChange(friend.friendid)}
                        style={{
                          width: 18,
                          height: 18,
                          cursor: "pointer",
                          accentColor: "#667eea",
                        }}
                      />
                    </div>

                    {/* Friend Avatar */}
                    <div style={{ textAlign: "center", marginBottom: "12px" }}>
                      <img 
                        src={friend.friendProfpic} 
                        alt={friend.friendid} 
                        style={{
                          width: "64px",
                          height: "64px",
                          borderRadius: "50%",
                          objectFit: "cover",
                          border: "2px solid rgba(102, 126, 234, 0.3)"
                        }}
                      />
                    </div>

                    {/* Friend Details */}
                    <div style={{ textAlign: "center", marginBottom: "12px", flex: 1 }}>
                      <p style={{ 
                        color: "white", 
                        fontWeight: "600", 
                        fontSize: "14px",
                        margin: "0 0 4px 0",
                        wordBreak: "break-word"
                      }}>
                        {friend.friendid}
                      </p>
                      <p style={{ 
                        color: "rgba(255,255,255,0.6)", 
                        fontSize: "11px",
                        margin: 0
                      }}>
                        📍 {friend.location}
                      </p>
                      <p style={{ 
                        color: "rgba(255,255,255,0.5)", 
                        fontSize: "10px",
                        margin: "2px 0 0 0"
                      }}>
                        {friend.activelevel}
                      </p>
                    </div>

                    {/* Action Buttons */}
                    <div style={{
                      display: "flex",
                      gap: "6px",
                      justifyContent: "center",
                    }}>
                      <button 
                        onClick={() => handleClick("messaging", friend.friendid, "friend")}
                        title="Send message"
                        style={{
                          flex: 1,
                          padding: "6px",
                          backgroundColor: "black",
                          border: "1px solid rgba(36,36,45,0.2)",
                          borderRadius: "4px",
                          color: "white",
                          cursor: "pointer",
                          transition: "all 0.2s",
                          fontSize: "12px",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = "rgba(102, 126, 234, 0.3)";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = "rgba(102, 126, 234, 0.2)";
                        }}
                      >
                        <FontAwesomeIcon icon={faMessage} />
                      </button>
                      <button 
                        onClick={() => handleClick("audio", friend.friendid, "friend")}
                        title="Audio call"
                        style={{
                          flex: 1,
                          padding: "6px",
                          backgroundColor: "black",
                          border: "1px solid rgba(36,36,45,0.2)",
                          borderRadius: "4px",
                          color: "white",
                          cursor: "pointer",
                          transition: "all 0.2s",
                          fontSize: "12px",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = "rgba(102, 126, 234, 0.3)";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = "rgba(102, 126, 234, 0.2)";
                        }}
                      >
                        <FontAwesomeIcon icon={faMobile} />
                      </button>
                      <button 
                        onClick={() => handleClick("video", friend.friendid, "friend")}
                        title="Video call"
                        style={{
                          flex: 1,
                          padding: "6px",
                          backgroundColor: "black",
                          border: "1px solid rgba(36,36,45,0.2)",
                          borderRadius: "4px",
                          color: "white",
                          cursor: "pointer",
                          transition: "all 0.2s",
                          fontSize: "12px",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = "rgba(102, 126, 234, 0.3)";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = "rgba(102, 126, 234, 0.2)";
                        }}
                      >
                        <FontAwesomeIcon icon={faVideoCamera} />
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

      ) : (

        // ✅ SUGGESTED FRIENDS SECTION
        <div style={{ width: "100%" }}>
          <h3 style={{ 
            color: "white", 
            marginBottom: "20px", 
            fontSize: "18px", 
            fontWeight: "600",
          }}>
            ✨ Suggested Connections ({suggestedUsers.length})
          </h3>

          {isLoadingSuggested ? (
            <p style={{ textAlign: "center", color: "rgba(255,255,255,0.6)", padding: "40px 0" }}>
              Loading suggestions...
            </p>
          ) : suggestedUsers.length === 0 ? (
            <p style={{ textAlign: "center", color: "rgba(255,255,255,0.6)", padding: "40px 0" }}>
              No suggested connections at the moment
            </p>
          ) : (
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(5, 1fr)",
              gap: "16px",
              width: "100%",
            }}>
              {suggestedUsers.map((user) => {
                const hasRequest = hasConnectionRequest(user.userId);

                return (
                  <div
                    key={user.userId}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      padding: "16px",
                      border: hasRequest
                        ? "2px solid #4caf50"
                        : "1px solid rgba(255,255,255,0.2)",
                      borderRadius: "12px",
                      transition: "all 0.3s ease",
                      backgroundColor: hasRequest ? "rgba(76, 175, 80, 0.08)" : "rgba(255,255,255,0.05)",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = hasRequest ? "rgba(76, 175, 80, 0.12)" : "rgba(255,255,255,0.08)";
                      e.currentTarget.style.transform = "translateY(-2px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = hasRequest ? "rgba(76, 175, 80, 0.08)" : "rgba(255,255,255,0.05)";
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    {/* User Avatar */}
                    <div style={{ textAlign: "center", marginBottom: "12px" }}>
                      <img
                        src={user.profileImage || "/assets/User/default-profile.jpg"}
                        alt={user.userName}
                        style={{
                          width: "64px",
                          height: "64px",
                          borderRadius: "50%",
                          objectFit: "cover",
                          border: "2px solid rgba(102, 126, 234, 0.3)",
                        }}
                      />
                    </div>

                    {/* User Details */}
                    <div style={{ textAlign: "center", marginBottom: "12px", flex: 1 }}>
                      <p
                        style={{
                          color: "white",
                          fontWeight: "600",
                          fontSize: "14px",
                          margin: "0 0 4px 0",
                          wordBreak: "break-word",
                        }}
                      >
                        {user.userName}
                      </p>
                      <p
                        style={{
                          color: "rgba(255,255,255,0.6)",
                          fontSize: "11px",
                          margin: 0,
                        }}
                      >
                        📍 {user.location || "Location unknown"}
                      </p>
                    </div>

                    {/* Action Buttons */}
                    <div style={{
                      display: "flex",
                      gap: "6px",
                      justifyContent: "center",
                    }}>
                      <button
                        onClick={() => handleConnectionToggle(user.userId, user.userName)}
                        style={{
                          flex: 1,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "6px",
                          borderRadius: "4px",
                          border: "none",
                          backgroundColor: hasRequest ? "#4caf50" : "rgba(255,255,255,0.1)",
                          color: hasRequest ? "white" : "rgba(255,255,255,0.6)",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = hasRequest ? "#45a049" : "rgba(255,255,255,0.2)";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = hasRequest ? "#4caf50" : "rgba(255,255,255,0.1)";
                        }}
                        title={hasRequest ? "Connection pending" : "Send connection request"}
                      >
                        <FontAwesomeIcon icon={faCheck} />
                      </button>

                      <button
                        onClick={() => handleConnectionToggle(user.userId, user.userName)}
                        style={{
                          flex: 1,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "6px",
                          borderRadius: "4px",
                          border: "none",
                          backgroundColor: "rgba(255,255,255,0.1)",
                          color: "rgba(255,255,255,0.6)",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = "#f44336";
                          e.target.style.color = "white";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = "rgba(255,255,255,0.1)";
                          e.target.style.color = "rgba(255,255,255,0.6)";
                        }}
                        title="Decline/Remove connection"
                      >
                        <FontAwesomeIcon icon={faTimes} />
                      </button>
                    </div>

                    {/* Status Badge */}
                    {hasRequest && (
                      <div
                        style={{
                          marginTop: "10px",
                          padding: "4px 8px",
                          backgroundColor: "rgba(76, 175, 80, 0.2)",
                          borderLeft: "2px solid #4caf50",
                          borderRadius: "3px",
                          textAlign: "center",
                        }}
                      >
                        <p
                          style={{
                            margin: 0,
                            fontSize: "10px",
                            color: "#4caf50",
                            fontWeight: "500",
                          }}
                        >
                          ✓ Request sent
                        </p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>

      )}
    </div>
  );
};

export default UFGridLowerLayout;
